/* eslint-disable @typescript-eslint/naming-convention */
import React from "react";
import type {} from "@mui/x-date-pickers/themeAugmentation";
import "dayjs/locale/en";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import DatePickerProps from "./DatePicker.types";
import { TextField } from "../../index";
import Calendar from "../../icons/Calendar";
import * as S from "./DatePicker.styles";

/**
 * BW DatePicker component.
 * This component is bootstrapped using MUI X.
 * @see https://mui.com/x/introduction/installation/
 * DatePicker component passes all available props down to the native Date Picker of MUI:
 * @see https://mui.com/x/api/date-pickers/date-picker/#props
 * @see https://mui.com/x/react-date-pickers/getting-started/
 * @see https://mui.com/x/api/date-pickers/date-picker/
 */
const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>((props, ref) => {
    const { id, name, labelText, placeholder, disabled, error, ...rest } = props;

    return (
        <LocalizationProvider adapterLocale="en" dateAdapter={AdapterDayjs}>
            <MuiDatePicker
                inputRef={ref}
                inputFormat="DD/MM/YYYY"
                InputProps={{
                    placeholder: placeholder
                }}
                components={{ OpenPickerIcon: Calendar }}
                {...rest}
                renderInput={({ inputRef, inputProps, InputProps }) => (
                    <S.CalanderIconWrapper disabled={disabled} error={error}>
                        <TextField
                            {...inputProps}
                            ref={inputRef}
                            id={id ?? name}
                            name={name}
                            tabIndex={disabled ? -1 : 0}
                            labelType="frame"
                            labelText={labelText}
                            placeholder={placeholder}
                            autoComplete="off"
                            error={error}
                        />
                        {InputProps?.endAdornment}
                    </S.CalanderIconWrapper>
                )}
            />
        </LocalizationProvider>
    );
});

DatePicker.defaultProps = {
    placeholder: "DD/MM/YYYY"
};

DatePicker.displayName = "DatePicker";

export default DatePicker;
